module.exports = __webpack_public_path__ + "static/img/icon_video2.dfb0629.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_video2.jpg
// module id = fD/j
// module chunks = 21